export function alignValue<T>(view: string, allowedValues: { [key: string]: T }): T {
  if (allowedValues[view]) {
    return allowedValues[view] as unknown as T;
  }
  return undefined as T;
}
